import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-privacy-policy',
  templateUrl: './view-privacy-policy.component.html',
  styleUrls: ['./view-privacy-policy.component.css']
})
export class ViewPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
